import { Dialog, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";

import InputField from "../../../components/InputField";
import Label from "../../../components/label";
import DialogHeader from "../../../components/dialog/DialogHeader";
import DialogBody from "../../../components/dialog/DialogBody";
import DialogActionButtons from "../../../components/dialog/DialogActions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};

const SaveChangesDialog = forwardRef(({ handleConfirm }, ref) => {
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setPasswordError(false);
    setPassword("");
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader title={"confirmation"} onClose={handleClose} />
      <DialogBody>
        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <Label text={t("password")} required htmlFor="user_save_pass" />
            <InputField
              id={"user_save_pass"}
              placeholder={`${t("enter")} ${t("password")}`}
              type={showPassword ? "password" : "text"}
              InputEndIcon={
                showPassword ? (
                  <VisibilityOffIcon
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPassword(false)}
                  />
                ) : (
                  <VisibilityIcon
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => setShowPassword(true)}
                  />
                )
              }
              inputError={passwordError}
              helperText={passwordError && t("passwordRequired")}
              name={"password"}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError(false);
              }}
            />
          </Grid>
        </Grid>
        <Typography variant="body1" fontWeight={500} my={2}>
          {t("confirmChangeAllDetails")}
        </Typography>
      </DialogBody>
      <DialogActionButtons
        onCancel={handleClose}
        onConfirm={() => {
          if (!password.trim()) {
            setPasswordError(true);
          } else {
            handleConfirm(password);
          }
        }}
      />
    </BootstrapDialog>
  );
});

export default SaveChangesDialog;
